import React from 'react';
import { TextInput, SelectInput, required, email, useTranslate } from 'react-admin';
import { FieldPair, FormSection } from '@/components/shell';
import { USER_ROLE_CHOICES } from '@/config/constants';

/** The fields of a user, shared by its create and edit pages. The email is the identity, so it is set once. */
export const UserFields: React.FC<{ mode: 'create' | 'edit' }> = ({ mode }) => {
  const t = useTranslate();
  // "NoAccess" cannot be assigned at creation — only the operational roles can.
  const roleChoices = USER_ROLE_CHOICES
    .filter((c) => mode === 'edit' || c.id !== 'NoAccess')
    .map((c) => ({ id: c.id, name: t(`roles.${c.id}`, { _: c.name }) }));

  return (
    <>
      <FormSection title={t('screens.users.sectionPerson')}>
        <FieldPair>
          <TextInput
            source="name"
            label={t('screens.users.fullName')}
            validate={required()}
            fullWidth
            helperText={mode === 'create' ? t('screens.users.fullNameHint') : undefined}
          />
          {mode === 'create' ? (
            <TextInput
              source="email"
              label={t('resources.users.fields.email')}
              validate={[required(), email()]}
              fullWidth
              type="email"
            />
          ) : (
            <TextInput
              source="email"
              label={t('resources.users.fields.email')}
              fullWidth
              disabled
              helperText={t('screens.users.emailLocked')}
            />
          )}
        </FieldPair>
      </FormSection>
      <FormSection title={t('screens.users.sectionRole')}>
        <SelectInput
          source="role"
          label={t('resources.users.fields.role')}
          choices={roleChoices}
          translateChoice={false}
          validate={required()}
          fullWidth
        />
      </FormSection>
    </>
  );
};
